import { parseUtcIso } from "@/utils/dateTime";
export const formatDistanceToNow = (dateString) => {
    try {
        const date = parseUtcIso(dateString);
        if (Number.isNaN(date.getTime()))
            return dateString;
        const now = new Date();
        const diffMs = now.getTime() - date.getTime();
        const diffSecs = Math.floor(diffMs / 1000);
        const diffMins = Math.floor(diffSecs / 60);
        const diffHours = Math.floor(diffMins / 60);
        const diffDays = Math.floor(diffHours / 24);
        if (diffSecs < 60) {
            return 'just now';
        }
        else if (diffMins < 60) {
            return `${diffMins} minute${diffMins !== 1 ? 's' : ''} ago`;
        }
        else if (diffHours < 24) {
            return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
        }
        else if (diffDays === 1) {
            return '1 day ago';
        }
        else if (diffDays < 7) {
            return `${diffDays} days ago`;
        }
        else if (diffDays < 30) {
            const weeks = Math.floor(diffDays / 7);
            return `${weeks} week${weeks !== 1 ? 's' : ''} ago`;
        }
        else if (diffDays < 365) {
            const months = Math.floor(diffDays / 30);
            return `${months} month${months !== 1 ? 's' : ''} ago`;
        }
        else {
            const years = Math.floor(diffDays / 365);
            return `${years} year${years !== 1 ? 's' : ''} ago`;
        }
    }
    catch {
        return dateString;
    }
};
